// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"rj-z","summaryPar":"sj-z","ratingCategories":"tj-z","reviewerInfo":"uj-z","reviewTypes":"vj-z","expanded":"wj-z"};